import { ErrorBoundary, VStack } from '@genial/components';
import React from 'react';

import { useFixedFeeTermAcceptance } from '../../hooks/useFixedFeeTermAcceptance';
import { TermActionBaseProps } from '../shared/TermAction/types';
import { TermAcceptance } from '../TermAcceptance';
import { TermRevocation } from '../TermRevocation';

export const TermFlow: React.FC = () => {
  const {
    termData,
    decision,
    error,
    loading,
    retry,
    handleAccept,
    handleRefuse,
    handleDownloadTerm,
  } = useFixedFeeTermAcceptance();

  const actionProps: TermActionBaseProps = {
    termData,
    loading,
    error,
    retry,
    handleAccept,
    handleRefuse,
    handleDownloadTerm,
  };

  const isRevocationFlow = termData?.actionType === 'revocation';

  if (decision) {
    const successMessageByFlow = isRevocationFlow
      ? {
          accepted: {
            title: 'Encerramento confirmado com sucesso',
            message: 'Recebemos sua confirmação e concluímos o encerramento deste termo.',
          },
          refused: {
            title: 'Encerramento recusado',
            message: 'Recebemos sua decisão e este termo permanecerá ativo.',
          },
        }
      : {
          accepted: {
            title: 'Termo aceito com sucesso',
            message: 'Recebemos o seu aceite e concluímos esta etapa.',
          },
          refused: {
            title: 'Termo recusado',
            message: 'Recebemos a recusa. Solicite um novo envio ao seu assessor, se necessário.',
          },
        };

    return (
      <VStack flex={1} justifyContent="center" px="inline.xxs">
        <ErrorBoundary
          errorIconOrIllustration={
            decision === 'accepted' ? 'SpreadsheetIllustration' : 'WarningIllustration'
          }
          errorTitle={successMessageByFlow[decision].title}
          errorMessage={successMessageByFlow[decision].message}
        />
      </VStack>
    );
  }

  if (isRevocationFlow) {
    return <TermRevocation {...actionProps} />;
  }

  return <TermAcceptance {...actionProps} />;
};
